import { enumToList } from '..';
import { Pipe, PipeTransform } from '@angular/core';
import { TrendingGroupByOption } from 'src/app/shared/enums/trending-group-by-option.enum';
import { IdName } from 'src/app/shared/models/id-name.model';

@Pipe({
  name: 'trendingGroupByOption',
  standalone: false
})
export class TrendingGroupByOptionPipe implements PipeTransform {
  public transform(value: TrendingGroupByOption): string {
    return getTrendingGroupByOption(value);
  }
}

export function getTrendingGroupByOption(value: TrendingGroupByOption): string {
  switch (value) {
    case TrendingGroupByOption.Phase:
      return 'Phase';
    case TrendingGroupByOption.Form5:
      return '5 Observations';
    case TrendingGroupByOption.Form10:
      return '10 Observations';
    case TrendingGroupByOption.Form20:
      return '20 Observations';
    default:
      throw new Error(`Unsupported value for TrendingGroupByOption: ${value}.`);
  }
}

export function getTrendingGroupByOptionList(): IdName[] {
  return enumToList(TrendingGroupByOption, getTrendingGroupByOption);
}
